export default function($) {
  $('.js-search-trigger').on('click', function() {
    $('.js-search-overlay').show();
    $('.js-search-overlay').find('input').focus();
  })

  $('.js-search-close').on('click', function() {
    $('.js-search-overlay').hide();
  })
}
